module.exports = __webpack_public_path__ + "img/alipay_oauth2.e1db6792.png";